import { Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { FormGroup, AbstractControl, FormBuilder, Validators } from '@angular/forms';
import { validateAllFormFields } from 'src/app/services/mapping.service';
import { AuthStore } from 'src/app/stores/auth/auth.store';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  form: FormGroup;
  email: AbstractControl;
  password: AbstractControl;

  error: any = null;
  constructor(
    private fb: FormBuilder,
    private router: Router,
    private store: AuthStore
  ) { }

  ngOnInit() {
    this.form = this.fb.group({
      email: [null, [Validators.required, Validators.email]],
      password: [null, Validators.required],
    })
    this.email = this.form.controls['userName'];
    this.password = this.form.controls['password'];
  }

  _onSignIn(f: any) {
    if (this.form.valid) {
      this.error = null;
      this.form.disable();
      this.store.signIn(f, (success) => {
        if (success) {
          this.router.navigate(['/'])
        }
        else {
          this.error = "Invalid your email and password. Please try again!";
        }
        this.form.enable();
      })
    }
    else {
      validateAllFormFields(this.form)
      this.form.enable();
      this.error = null;
    }
  }


}
